var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLessThanEqual(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M440 439.998H8C3.594 439.998 0 443.592 0 447.999S3.594 456 8 456H440C444.406 456 448 452.406 448 447.999S444.406 439.998 440 439.998ZM61.031 199.406L381.031 327.422C381.999 327.797 383 327.984 384 327.984C387.188 327.984 390.188 326.078 391.438 322.952C393.062 318.858 391.062 314.201 386.969 312.545L85.531 191.968L386.969 71.39C391.063 69.734 393.063 65.077 391.438 60.983C389.781 56.889 385.062 55.013 381.031 56.514L61.031 184.529C57.999 185.748 56 188.686 56 191.968C56 195.249 57.999 198.187 61.031 199.406Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLessThanEqual);
export default __webpack_public_path__ + "static/media/less-than-equal.01493d851a29ce85741e15a7a83db97c.svg";
export { ForwardRef as ReactComponent };